export const CONTENT_APPROVAL_FLEET_SUCCESS = "CONTENT_APPROVAL_FLEET_SUCCESS";
export const CONTENT_APPROVAL_FLEET_ERROR = "CONTENT_APPROVAL_FLEET_ERROR";
export const CONTENT_APPROVAL_FLEET_START = "CONTENT_APPROVAL_FLEET_START";

export const SAVE_CONTENT_APPROVAL_FLEET_START =
  " SAVE_CONTENT_APPROVAL_FLEET_START";
export const SAVE_CONTENT_APPROVAL_FLEET_SUCCESS = "SAVE_GENRAL_FLEET_SUCCESS";
export const SAVE_CONTENT_APPROVAL_FLEET_ERROR = "SAVE_GENRAL_FLEET_ERROR";
